var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-left",
    on: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = _vm.$root.show.appLeft || 1
      }
    }
  }, [_c('a', {
    staticClass: "btn btn-soft",
    attrs: {
      "href": "#!create"
    },
    on: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 1
      }
    }
  }, [_vm._v("New")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-soft",
    attrs: {
      "href": "#!create"
    },
    on: {
      "mouseenter": function($event) {
        _vm.$root.show.appLeft = 2
      }
    }
  }, [_vm._v("Recent")]), _vm._v(" "), (_vm.$root.show.appLeft === 2) ? _c('div', {
    staticClass: "app-left-nested"
  }, [_c('nav', {
    staticClass: "nav-content"
  }, [_c('recent-fragments', {
    staticClass: "nav-fixwidth"
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.$root.show.appLeft === 1) ? _c('div', {
    staticClass: "app-left-nested"
  }, [_c('div', {
    staticClass: "app-left__btns"
  }, [_c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Address')
      }
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Invoice')
      }
    }
  }, [_vm._v("Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('LocalBusiness')
      }
    }
  }, [_vm._v("LocalBusiness")]), _vm._v(" "), _c('button', {
    staticClass: "btn-type fragment-type",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.createByType('Person')
      }
    }
  }, [_vm._v("Person")])])]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a05559","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppLeft.vue
// module id = 27
// module chunks = 1